export const pathRegexPattern = /^\/([a-zA-Z]*)\/?/;
